import inhaler from "../../../../assets/images/Inhaler.png";
import eyeDrop from "../../../../assets/images/eye_drop.png";
import misc from "../../../../assets/images/miscellaneous_package.png";
import ointment from "../../../../assets/images/Ointment.png";
import syringe from "../../../../assets/images/syringe.png";
import syrup from "../../../../assets/images/syrup_spoon.png";
import tablet from "../../../../assets/images/tablet_pills.png";
import others from "../../../../assets/images/others.png";

export const formIcons = {
	tablet,
	tablet_sr: tablet,
	tablet_md: tablet,
	tablet_mr: tablet,
	tablet_pr: tablet,
	tablet_er: tablet,
	tablet_fc: tablet,
	tablet_cr: tablet,
	tablet_xl: tablet,
	tablet_dt: tablet,
	tablet_combikit: tablet,
	tablet_combipack: tablet,
	chewable_tablet: tablet,
	effervescent_tablet: tablet,
	sublingual_tablet: tablet,
	syrup,
	dry_syrup: syrup,
	oral_suspension: syrup,
	suspension: syrup,
	rediuse_suspension: syrup,
	expectorant: syrup,
	ointment,
	cream: ointment,
	gel: ointment,
	paste: ointment,
	eye_drop: eyeDrop,
	ear_drop: eyeDrop,
	eye_ointment: eyeDrop,
	ophthalmic_solution: eyeDrop,
	eye_ear_drop: eyeDrop,
	nasal_spray: inhaler,
	spray: inhaler,
	respule: inhaler,
	injection: syringe,
	solution_for_injection: syringe,
	solution_for_infusion: syringe,
	infusion: syringe,
	vial: syringe,
	default: misc,
	otc: others,
};

export const resolveFormIcon = (product) => {
	const formValue = product?.productForm?.toLowerCase().replace(/\s+/g, "_");

	if (product?.isOTC) {
		return others;
	}

	return formIcons[formValue] || formIcons.default;
};

